module.exports = __webpack_public_path__ + "06dbb5aacb7fc87ff66a1aea8a831da4.png";